import $ from 'jquery';
import FavouriteArrangements from '../../components/FavouriteArrangements';
import SortingComponent from '../../components/SortingComponent';
import ajaxService from '../../services/ajaxService';
import contentService from '../../services/contentService';
import userCookiesService from '../../services/userCookiesService';
import {
	initPaymentInstallmentsTestForArrangementList
} from '../../helpers/abTestHelpers';
import {lazyLoad} from '../../helpers/lazyLoadHelpers';

const DEFAULT_SORTING_VALUE = 'date_asc';

class FavouriteArrangementsPage {
	constructor() {
		this.init();
	}

	init() {
		this.favouriteArrangements = new FavouriteArrangements({
			'onFavouriteChange': ({added, id}) => {
				if (!added) {
					this.removeArrangementRow(
						this.getArrangementRowById(id)
					);
				}
			}
		});
		new SortingComponent({
			'onSelect': this.sortArrangements.bind(this)
		});
		this.initEvents();
		initPaymentInstallmentsTestForArrangementList();
	}

	sortArrangements(selectedSorting) {
		this.addLoader();

		this.fetchArrangements(
			this.getSelectedSortingQuery(selectedSorting)
		)
			.then(
				this.updatePageByResponse.bind(this),
				this.removeLoader.bind(this)
			);
	}

	fetchArrangements(sortingQuery) {
		return ajaxService.sendGet(`user/favourites/arrangements/${sortingQuery}`);
	}

	updatePageByResponse(response) {
		if (response) {
			$('.filteredArrangementsContainer').html(response.favouriteArrangementsBlock);
			this.favouriteArrangements.setFavoritedIconsLook();
			this.removeLoader();
			contentService.initPopovers({
				'params': contentService.customPopOverMarkup()
			});

			requestAnimationFrame(() => {
				const arrangementListItemClubLogoStr = '.arrangementListItem .clubLogo';

				if ($(arrangementListItemClubLogoStr).length) {
					lazyLoad({
						'elements_selector': arrangementListItemClubLogoStr
					});
				}
			});
		}
	}

	getSelectedSortingQuery(selectedSorting) {
		if (selectedSorting !== DEFAULT_SORTING_VALUE) {
			return `?order=${selectedSorting}`;
		}

		return '';
	}

	addLoader() {
		$('.filteredArrangementsContainer').append('<div class="loader"></div>');
	}

	removeLoader() {
		$('.loader').remove();
	}

	initEvents() {
		let lastClickStamp = 0;

		$('.filteredArrangementsContainer').on('click', '.wishlistRemoveIcon i', (ev) => {
			const $removeIcon 		= $(ev.currentTarget).parent(),
				  $arrangementRow 	= $removeIcon.closest('.match'),
				  arrangementId 	= $removeIcon.data('arrangementId'),
				  clickStamp 		= Date.now(),
				  diff 				= (clickStamp - lastClickStamp);

			if (diff > 300) {
				this.removeArrangementRow($arrangementRow);
				this.favouriteArrangements.saveOrRemoveId(arrangementId);
			}

			lastClickStamp = clickStamp;
		});
	}

	getArrangementRowById(id) {
		return $(`.filteredArrangementsContainer .wishlistIcon[data-arrangement-id=${id}]`).closest('.match');
	}

	removeArrangementRow($arrangementRow) {
		$arrangementRow.fadeOut(300, () => {
			$arrangementRow.remove();
			this.onArrangementRowRemove();
		});
	}

	onArrangementRowRemove() {
		// show no results message when there are no more favourite ids
		if (!userCookiesService.getFavouriteArrangementIds().length) {
			$('.no_results_container').show();
		}

		if (userCookiesService.getFavouriteArrangementIds().length < 2) {
			$('.line, .order').remove();
		}
	}
}

new FavouriteArrangementsPage();